import TYPES from '../../types';

// Domain
import { CustomerDocumentsRepository } from '../../domain/repositories/customer-documents-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Command from '@/modules/shared/domain/use-cases/command';

@Injectable()
export default class RequestUpdateCustomerDocumentIneCommand extends Command {
  @Inject(TYPES.CUSTOMER_DOCUMENTS_REPOSITORY)
  private readonly repository!: CustomerDocumentsRepository;

  internalExecute(): Promise<void> {
    return this.repository.request_update_ine();
  }
}
